'use client';
import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

import { useT } from '@/hooks';

interface CommentControlsProps {
  sortBy: string;
  onSortChange: (val: string) => void;
  showHolders: boolean;
  onHoldersToggle: (val: boolean) => void;
}

export function CommentControls({
  sortBy,
  onSortChange,
  showHolders,
  onHoldersToggle,
}: CommentControlsProps) {
  const { t } = useT();

  function handleSortChange(e: any) {
    onSortChange(e.target.value as string);
  }

  function handleHoldersToggle(e: React.ChangeEvent<HTMLInputElement>) {
    onHoldersToggle(e.target.checked);
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={sortBy}
          onChange={handleSortChange}
          sx={{ borderRadius: 2, fontSize: '0.875rem' }}
        >
          <MenuItem value="newest">{t('filter.Newest')}</MenuItem>
          <MenuItem value="oldest">{t('filter.Oldest')}</MenuItem>
        </Select>
      </FormControl>
      <FormControlLabel
        control={<Checkbox checked={showHolders} onChange={handleHoldersToggle} size="small" />}
        label={
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            {t('market.holders')}
          </Typography>
        }
      />
    </Box>
  );
}

export default CommentControls;
